import React from 'react'

const Header = () => {
    return (
        <div className='header'>

            <div className='header2'>
                <p>Doctor Contact : +91 94150 26762</p>
            </div>

            <div className='header2'>
                <p>Sector - A, Pocket - 1, Amar Shaheed Path, Golf City, Lucknow Uttar Pradesh 226030</p>
            </div>

        </div>
    )
}

export default Header